import React, {useState} from "react";
import {Box, Dialog, DialogContent, IconButton} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import CloseIcon from "@mui/icons-material/Close";

import "swiper/css";
import "swiper/css/navigation";

export default function ImageCarousel({images, maxWidth, slidesToShow = {sm: 3, xl: 5}, imageHeight = {xs: 250, md: 280, xl: 300}, showArrows = true, delay = 6000}) {
    const [open, setOpen] = useState(false);
    const [fullImageSrc, setFullImageSrc] = useState(null);
    const handleOpen = (src) => {
        setFullImageSrc(src);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);
    return (
        <>
        <Box sx={{ position: "relative", width: "100%", maxWidth: maxWidth}}>
            <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={16}
                slidesPerView={1} // default
                navigation={{
                    prevEl: ".swiper-prev",
                    nextEl: ".swiper-next",
                }}
                autoplay={{
                    delay: delay,
                    disableOnInteraction: false,
                }}
                loop={images.length > 2}
                breakpoints={{
                    600: { slidesPerView: slidesToShow.sm ? slidesToShow.sm : 1 },
                    1536: { slidesPerView: slidesToShow.xl ? slidesToShow.xl : 1 }
                }}
            >
                {images.map((src, index) => {
                    var objectPosition = "center";
                    if (src.includes("-top")) {
                        objectPosition = "top"
                    }
                    return <SwiperSlide key={index}>
                        <Box
                            onClick={() => handleOpen(src)}
                            component="img"
                            src={src}
                            alt={`slide-${index}`}
                            sx={{
                                width: "100%",
                                height: imageHeight,
                                objectFit: "cover",
                                objectPosition: objectPosition,
                                borderRadius: 2,
                                boxShadow: 2,
                            }}
                        />
                    </SwiperSlide>
                })}
            </Swiper>

            {/* Bottoni freccia */}
            {showArrows && <>
                <IconButton
                    className="swiper-prev"
                    sx={(theme) => ({
                        position: "absolute",
                        top: "50%",
                        left: 16,
                        zIndex: 10,
                        transform: "translateY(-50%)",
                        color: theme.palette.text.primary,
                        backgroundColor: false,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        "&:hover": { backgroundColor: theme.palette.background.default },
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    <ArrowBackIos sx={{ ml: 1 }} /> {/* piccolo margine a sinistra per centrare l’icona */}
                </IconButton>
                <IconButton className="swiper-next"
                            sx={(theme) => ({
                                position: "absolute",
                                top: "50%",
                                right: 16,
                                zIndex: 10,
                                transform: "translateY(-50%)",
                                color: theme.palette.text.primary,
                                backgroundColor: false,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                "&:hover": {
                                    backgroundColor: theme.palette.background.default,
                                },
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                            })}>
                    <ArrowForwardIos/>
                </IconButton>
            </>
            }
        </Box>
            {/* Dialog fullscreen */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen
                slotProps={{
                    paper: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            backdropFilter: "blur(4px)",
                        },
                    },
                }}
            >
                {/* Bottone chiudi */}
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "white",
                        zIndex: 10,
                    }}
                >
                    <CloseIcon/>
                </IconButton>

                {/* Contenuto immagine */}
                <DialogContent
                    onClick={handleClose}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 0,
                        height: "100vh",
                        cursor: "zoom-out",
                    }}
                >
                    <Box
                        component="img"
                        src={fullImageSrc}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            maxWidth: "90%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            borderRadius: 2,
                            boxShadow: 3,
                            cursor: "default",
                        }}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}